import { create } from "zustand";
import { persist } from "zustand/middleware";

import { DEFAULT_LANGUAGE, isLanguageSelectionEnabled } from "~/config/language";

import { isSupportedLanguage } from "../../../../utils/browser-language";

import type { SupportedLanguages } from "@repo/shared";

type LanguageStore = {
  language: SupportedLanguages;
  setLanguage: (lang: SupportedLanguages) => void;
  initializeLanguage: (applicationLang?: string | null) => SupportedLanguages;
};

export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set, get) => ({
      language: DEFAULT_LANGUAGE,
      setLanguage: (lang) => {
        if (!isLanguageSelectionEnabled) {
          set({ language: DEFAULT_LANGUAGE });
          return;
        }
        set({ language: lang });
      },
      initializeLanguage: (applicationLang) => {
        if (!isLanguageSelectionEnabled) {
          set({ language: DEFAULT_LANGUAGE });
          return DEFAULT_LANGUAGE;
        }

        const currentState = get();

        if (applicationLang && isSupportedLanguage(applicationLang)) {
          set({ language: applicationLang });
          return applicationLang;
        }

        if (currentState.language && isSupportedLanguage(currentState.language)) {
          return currentState.language;
        }

        set({ language: DEFAULT_LANGUAGE });
        return DEFAULT_LANGUAGE;
      },
    }),
    {
      name: "language-storage",
    },
  ),
);
